import { Options, Vue } from 'vue-class-component';
import { Inject, Prop } from 'vue-property-decorator';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import TimesheetCalculationsMixin from '@/shared/mixins/timesheet-calculations';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { TrustAPI } from '@/shared/modules/trust-api';
import { Investigator } from './investigator';

@Options({
	mixins: [FormatDateTimeMixin, TimesheetCalculationsMixin]
})
export default class DashboardStats extends Vue {
	private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private investigatorDetails!: Investigator;

  @Prop() 
  private leaveScheduled!: number;

  @Prop()
  private isPortalOffline!: boolean;

  private goToInvestigations(): void {
    this.$emit('goToInvestigations');
  }
	
}
